import { initSpamOption, SpamScenarioId } from 'owa-spam-row-option';
import { runAfterBootstrap } from 'owa-delayed-initialization';
export { default as SafeMailingListsOptionV2 } from './SafeMailingListsOptionV2';

runAfterBootstrap(() => {
    initSpamOption(SpamScenarioId.SafeMailingLists);
});
